import { render, staticRenderFns } from "./tan_trans_return.vue?vue&type=template&id=388c5dad&scoped=true"
import script from "./tan_trans_return.vue?vue&type=script&lang=js"
export * from "./tan_trans_return.vue?vue&type=script&lang=js"
import style0 from "./tan_trans_return.vue?vue&type=style&index=0&id=388c5dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c5dad",
  null
  
)

export default component.exports